// Build-version kill switch. Each deploy stamps a build id into the built
// index.html (window.__BUILD_ID__) and into /build-version.json (served fresh).
// If the running app's baked-in id no longer matches the deployed one, we hard-
// reload to pull the newest build — reliable even when the iOS service-worker
// update path doesn't fire. See client/scripts/stamp-version.js.

export async function checkVersion() {
  try {
    const baked = window.__BUILD_ID__;
    if (!baked) return;                       // dev build / not stamped
    const r = await fetch('/build-version.json', { cache: 'no-store' });
    if (!r.ok) return;
    const { build } = await r.json();
    if (!build || build === baked) return;    // up to date
    // New deploy detected. Guard against a reload loop: if we already reloaded
    // for this exact version and it's still stale, don't spin.
    if (sessionStorage.getItem('reloadedForVersion') === build) return;
    sessionStorage.setItem('reloadedForVersion', build);
    window.location.reload();
  } catch { /* offline or blocked — leave the current build running */ }
}
